
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexAwDvH0TinTnNx41SHw5hylKtWvLsK_45xZYOMwIksYQCgMeta } from "/usr/local/app/apps/reelio.cz/app/pages/index.vue?macro=true";
import { default as searchhOFn5D1W3XlubSp6NIphRyOCAu5_45FaAnXdwiaJeMnWkMeta } from "/usr/local/app/apps/reelio.cz/app/pages/search.vue?macro=true";
import { default as accountET4IYJFT5jjQ_45oJ9JFJxFWR8zd7aMMz_aElWAjNGrfYMeta } from "/usr/local/app/apps/reelio.cz/app/pages/account.vue?macro=true";
import { default as _91slug_93ARKksdu1FiM950QZnVM5hFHaMQ4DBavlOMZKSaqmYmUMeta } from "/usr/local/app/apps/reelio.cz/app/pages/pages/[slug].vue?macro=true";
import { default as indexLe_45lwgjCH9KRYTOvY_45gNwMkJH4b0inB4mHjLNz9tx7kMeta } from "/usr/local/app/apps/reelio.cz/app/pages/checkout/index.vue?macro=true";
import { default as _91slug_93Sp1nD7wOGd2vOxWax8pD94gwE41X30KeFreFcOM5WT4Meta } from "/usr/local/app/apps/reelio.cz/app/pages/stores/[id]/[slug].vue?macro=true";
import { default as _91_91slug_93_93GJzbN7D_sq65Ep9SeBhOd9IR0LtlPU4uWcExdEw7jlsMeta } from "/usr/local/app/apps/reelio.cz/app/pages/products/[id]/[[slug]].vue?macro=true";
import { default as best_45sellersOEoYqivgkb7UdODCKE0_hgO3iDg9E5385sAJ5eHMDscMeta } from "/usr/local/app/apps/reelio.cz/app/pages/collections/best-sellers.vue?macro=true";
import { default as new_45arrivalsdDUlvFRb6zODmb8zqlxDaAC7kcFSueHusTPVI46PKt0Meta } from "/usr/local/app/apps/reelio.cz/app/pages/collections/new-arrivals.vue?macro=true";
import { default as _91_91slug_93_93x8gQj5Lcr2JK_WpJXuCAUjoh8sbxuyc9L59wsuO36A4Meta } from "/usr/local/app/apps/reelio.cz/app/pages/collections/[id]/[[slug]].vue?macro=true";
import { default as _91code_93gbqkPDY7lAUmdmQUS_45XoCDPjlvPDEpL03KyBfu3yxHsMeta } from "/usr/local/app/apps/reelio.cz/app/pages/checkout/confirmation/[code].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/usr/local/app/apps/reelio.cz/app/pages/index.vue")
  },
  {
    name: "index___cs",
    path: "/cs",
    component: () => import("/usr/local/app/apps/reelio.cz/app/pages/index.vue")
  },
  {
    name: "search___cs",
    path: "/cs/search",
    component: () => import("/usr/local/app/apps/reelio.cz/app/pages/search.vue")
  },
  {
    name: "account___cs",
    path: "/cs/account",
    meta: accountET4IYJFT5jjQ_45oJ9JFJxFWR8zd7aMMz_aElWAjNGrfYMeta || {},
    component: () => import("/usr/local/app/apps/reelio.cz/app/pages/account.vue")
  },
  {
    name: "pages-slug___cs",
    path: "/cs/pages/:slug()",
    component: () => import("/usr/local/app/apps/reelio.cz/app/pages/pages/[slug].vue")
  },
  {
    name: "checkout___cs",
    path: "/cs/checkout",
    component: () => import("/usr/local/app/apps/reelio.cz/app/pages/checkout/index.vue")
  },
  {
    name: "stores-id-slug___cs",
    path: "/cs/stores/:id()/:slug()",
    component: () => import("/usr/local/app/apps/reelio.cz/app/pages/stores/[id]/[slug].vue")
  },
  {
    name: "products-id-slug___cs",
    path: "/cs/products/:id()/:slug?",
    component: () => import("/usr/local/app/apps/reelio.cz/app/pages/products/[id]/[[slug]].vue")
  },
  {
    name: "collections-best-sellers___cs",
    path: "/cs/collections/best-sellers",
    component: () => import("/usr/local/app/apps/reelio.cz/app/pages/collections/best-sellers.vue")
  },
  {
    name: "collections-new-arrivals___cs",
    path: "/cs/collections/new-arrivals",
    component: () => import("/usr/local/app/apps/reelio.cz/app/pages/collections/new-arrivals.vue")
  },
  {
    name: "collections-id-slug___cs",
    path: "/cs/collections/:id()/:slug?",
    component: () => import("/usr/local/app/apps/reelio.cz/app/pages/collections/[id]/[[slug]].vue")
  },
  {
    name: "checkout-confirmation-code___cs",
    path: "/cs/checkout/confirmation/:code()",
    component: () => import("/usr/local/app/apps/reelio.cz/app/pages/checkout/confirmation/[code].vue")
  }
]